import Marquee from 'react-fast-marquee'

import styles from './OpportunitySubhead.module.scss'
import { OpportunitySubheadData } from './OpportunitySubheadData'
import Bubble from '../common/bubble/Bubble'
import { Flex } from '../common/flex/Flex'
import { Typography } from '../common/Typography/Typography'

const title = 'Opportunity-Makers Welcome'
const text =
  'Have a market-defining product idea? The Innovation Process gives you the opportunity to discover if it’s the real deal.'
const bubbleText = 'Do you have a winner?'
const marqueeText = 'Best of the best of the best of the best of the best of the best of the'

const OpportunitySubhead = () => {
  return (
    <Flex direction="column" gap={85} className={styles.container}>
      <Flex direction="column" className={styles.titleTextContainer} gap={16}>
        <Typography type="5xl-display" tag="h2" className={styles.title} color="#00531c">
          {title}
        </Typography>
        <Typography type="m-body" tag="p" className={styles.text}>
          {text}
        </Typography>
        <Bubble color="#EBFF00" text={bubbleText} direction="up" className={styles.bubble} />
      </Flex>
      <Flex gap={86} className={styles.contentContainer}>
        {OpportunitySubheadData.map(item => {
          return (
            <Flex direction="column" gap={16} className={styles.cardContainer} key={item.title}>
              <div className={styles.imgContainer}>
                <img src={item.img} alt="" />
              </div>
              <p className={styles.cardTitle}>{item.title}</p>
              <p className={styles.cardText}>{item.description}</p>
            </Flex>
          )
        })}
      </Flex>
      <Marquee className={styles.marqueeContainer}>
        <p className={styles.marqueeText}>{marqueeText}</p>
      </Marquee>
    </Flex>
  )
}

export default OpportunitySubhead
